import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import App from './app/App.vue';
import router from './app/router';
import store from './app/store';
import './styles/index.scss';

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueAnalytics, {
  id: 'UA-2381362-10',
  router,
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production',
  },
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
